import { createSettingPaymentPeriod, deleteSettingPaymentPeriod, getSettingPaymentPeriods, patchSettingPaymentPeriod } from "../api/EnzianSettingsApi";
import { handleStoreError } from "./GeneralStore";
import { createSimpleListConfiguration, createSimpleListListFilter } from "../types/ListTypes";
import { _ } from "svelte-i18n";
import { get } from "svelte/store";
export function createSettingPaymentPeriodStore() {
    let settingPaymentPeriodStore = $state([]);
    let storeListeners = $state([]);
    let listFilter = $state(createSimpleListListFilter({
        localStorageKey: 'setting-paymnet-periods',
        showFilterIcon: false,
        filterOptions: [
            {
                label: get(_)('settings.basic.payment_periods.values.lbl_name'),
                value: null,
                key: 'defaultName',
                type: 'string',
                isSorting: false
            }
        ]
    }));
    let listConfig = $state(createSimpleListConfiguration({
        header: get(_)('settings.basic.payment_periods.list_header'),
        showEmptyAdd: false,
        cardModeConfig: {
            amountOfCols: 4
        }
    }));
    async function loadData() {
        try {
            //Load the payment periods.
            const paymentPeriods = await getSettingPaymentPeriods(listFilter);
            if (listFilter.page == 0) {
                settingPaymentPeriodStore = paymentPeriods;
            }
            else {
                settingPaymentPeriodStore.push(...paymentPeriods);
            }
            if (settingPaymentPeriodStore.length > 0) {
                listFilter.page += 1;
            }
        }
        catch (error) {
            handleStoreError('settings.basic.payment_periods.err_load_payment_periods', error);
        }
    }
    return {
        set data(value) { settingPaymentPeriodStore = value; },
        get data() {
            return settingPaymentPeriodStore;
        },
        get listFilter() { return listFilter; },
        set listFilter(value) { listFilter = value; },
        get listConfig() { return listConfig; },
        set listConfig(value) { listConfig = value; },
        addNotifier(listener) {
            storeListeners.push(listener);
        },
        removeNotifier(listener) {
            storeListeners = storeListeners.filter((li) => li == listener);
        },
        loadData: loadData,
        async applyFilter() {
            //Reset the start id
            listFilter.page = 0;
            //Load the data.
            await loadData();
            //Inform the listeners
            storeListeners.forEach((listener) => {
                //Call the event
                listener.onFilterApplied();
            });
        },
        clear() {
            settingPaymentPeriodStore = [];
        },
        async createSettingPaymentPeriodStore(periodName) {
            //Send the web request
            const newPaymentPeriod = await createSettingPaymentPeriod({
                defaultName: periodName
            });
            //Add it to the data list
            settingPaymentPeriodStore.push(newPaymentPeriod);
        },
        async patchSettingPaymentPeriodStore(settingPaymentPeriodId, request) {
            //Send the web request
            const updatedValue = await patchSettingPaymentPeriod(settingPaymentPeriodId, request);
            //Add it to the data list
            const index = settingPaymentPeriodStore.findIndex((setting) => setting.id == settingPaymentPeriodId);
            if (index < 0) {
                return;
            }
            settingPaymentPeriodStore[index] = updatedValue;
        },
        async deleteSettingPaymentPeriodStore(item) {
            //Delete the item
            try {
                //Send the webrequest.
                await deleteSettingPaymentPeriod(item.id);
                //Remove it from the list
                settingPaymentPeriodStore = settingPaymentPeriodStore.filter((val) => val.id != item.id);
            }
            catch (error) {
                handleStoreError('settings.basic.payment_periods.err_delete_paymnet_period', error);
            }
        }
    };
}
